<template>
  <div class="jour_page">
    <div class="company_title" @click="selTabber(3)">新闻中心</div>
    <div class="company_warn">聚焦小绿新闻，了解小绿发展大事记</div>
    <div class="industry_information" v-if="list && list.length">
      <div class="industry_left" @click="gotoDetails(list[0].id)">
        <!-- <img class="industry_img" src="/static/img/index/anAssembly.png" alt=""> -->
        <div
          class="industry_img"
          :style="'background-image: url(' + req + list[0].cover + ');'"
        ></div>
        <div class="industry_word">
          <div class="industry_title">{{ list[0].title }}</div>
          <div class="industry_choice">
            <div class="industry_time">{{ list[0].releaseDate }}</div>
            <div class="industry_details">查看详情</div>
          </div>
        </div>
      </div>
      <div class="industry_right">
        <template v-for="(item, index) in list">
          <div
            class="recommend"
            @click="gotoDetails(list[index].id)"
            :key="index"
            v-if="index > 0 && index < 4"
          >
            <!-- <div class="recommend_image" :style="'background-image: url('+req+item.image_input+');'"></div> -->

            <img class="recommend_image" :src="req + item.cover" alt="" />
            <div class="recommend_word">
              <div class="recommend_title">{{ item.title }}</div>
              <div class="recommend_text">{{ item.synopsis }}</div>
              <div class="industry_choice">
                <div class="industry_time">{{ item.releaseDate }}</div>
                <div class="industry_details">查看详情</div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    list: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      req: "https://sign.xiaolvt.com",
    };
  },
  //过滤器
  filters: {},
  // 计算属性
  computed: {},
  // 监听器
  Watch: {},
  //生命周期 创建后
  created() {},
  // 挂载后
  mounted() {},
  // 销毁前
  beforeDestroy() {},
  //自定义函数
  methods: {
    selTabber(e) {
      this.$emit("selTabber", e);
    },
    gotoDetails(e) {
      this.$emit("gotoDetails", e);
    },
  },
};
</script>

<style scoped lang="scss">
@import url(../home.css);
.jour_page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
@media screen and (min-width: 1200px) {
  .industry_information {
    margin-top: 30px;
    width: 1200px;
    display: flex;
    .industry_left {
      width: 590px;
      .industry_img {
        width: 590px;
        height: 358px;
        background-size: cover;
        flex: none;
      }
      .industry_title {
        margin-top: 8px;
        font-size: 16px;
        font-weight: bold;
        color: #333333;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .industry_title:hover {
        color: #0ea049;
        cursor: pointer;
      }
      .industry_choice {
        margin-top: 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
        color: #999999;
      }
    }
    .industry_right {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-left: 21px;
      .recommend {
        display: flex;
        width: 579px;
        .recommend_image {
          object-fit: cover;
          width: 180px;
          height: 130px;
          margin-right: 15px;
          // background-size: cover;
          flex: none;
        }
        .recommend_word {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 579px;
          .recommend_title {
            font-size: 16px;
            font-weight: bold;
            color: #333333;
            word-break: break-all;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
          .recommend_title:hover {
            color: #0ea049;
            cursor: pointer;
          }
          .recommend_text {
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
            color: #666666;
            word-break: break-all;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
          .industry_choice {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-weight: 400;
            font-size: 12px;
            color: #999999;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 1000px) and (max-width: 1200px) {
  .industry_information {
    margin-top: 1.875rem;
    width: 75rem;
    display: flex;
    .industry_left {
      width: 36.875rem;
      .industry_img {
        width: 36.875rem;
        height: 22.375rem;
        background-size: cover;
        flex: none;
      }
      .industry_title {
        margin-top: 0.5rem;
        font-size: 1rem;
        font-weight: bold;
        color: #333333;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .industry_title:hover {
        color: #0ea049;
        cursor: pointer;
      }
      .industry_choice {
        margin-top: 1.5rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 0.75rem;
        color: #999999;
      }
    }
    .industry_right {
      width: 37.5rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-left: 1.3125rem;
      .recommend {
        display: flex;
        .recommend_image {
          width: 11.25rem;
          height: 8.125rem;
          margin-right: 0.9375rem;
          object-fit: cover;
          flex: none;
        }
        .recommend_word {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .recommend_title {
            font-size: 1rem;
            font-weight: bold;
            color: #333333;
            word-break: break-all;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
          .recommend_title:hover {
            color: #0ea049;
            cursor: pointer;
          }
          .recommend_text {
            font-size: 0.875rem;
            font-weight: 400;
            line-height: 1.375rem;
            color: #666666;
            word-break: break-all;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
          .industry_choice {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-weight: 400;
            font-size: 0.75rem;
            color: #999999;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1000px) {
  .industry_information {
    margin-top: 0.625rem;
    width: 23.4375rem;
    padding: 0 1rem;
    // letter-spacing: 0.2em;
    box-sizing: border-box;
    .industry_left {
      display: flex;
      .industry_img {
        width: 6.9375rem;
        height: 5rem;
        background-size: cover;
        flex: none;
      }
      .industry_word {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-left: 0.5rem;
        .industry_title {
          font-weight: bold;
          font-size: 0.875rem;
          color: #333333;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
        .industry_choice {
          margin-top: 0.1875rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 0.75rem;
          color: #999999;
          line-height: 1rem;
          .industry_details {
            color: #999999;
          }
        }
      }
    }
    .industry_right {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .recommend {
        display: flex;
        margin-top: 0.75rem;
        .recommend_image {
          width: 6.9375rem;
          height: 5rem;
          margin-right: 0.5rem;
          object-fit: cover;
          flex: none;
        }
        .recommend_word {
          display: flex;
          flex: 1;
          flex-direction: column;
          justify-content: space-between;
          overflow: hidden;
          .recommend_title {
            font-weight: bold;
            font-size: 0.875rem;
            color: #333333;
            word-break: break-all;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
          .recommend_text {
            display: none;
          }
          .industry_choice {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-weight: 400;
            font-size: 0.75rem;
            color: #999999;
            .industry_details {
              color: #999999;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/home-journalism.vue